
import Login from "./login.js";

export function bind() {
    return new Login();
}


// WEBPACK FOOTER //
// ./project/client/src/core/components/login/index.js